import { FileWithPreview } from '../../referralNetworkQuestionnaire';
import { UploadDocumentsError } from '../errors/UploadDocuments.error';
import { httpErrorHandler } from '../util/httpErrorHandler';

export type UploadedDocumentResponse = {
  filename: string;
  url: string;
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const findAttachments = (tasks: Record<string, any>): FileWithPreview[] => {
  return tasks.task14.attachments as FileWithPreview[];
};

export const uploadAttachments = async (
  attachments: FileWithPreview[],
  identityId: string,
  answerId: string,
): Promise<UploadedDocumentResponse[]> => {
  const formData = new FormData();
  attachments?.forEach((file) => {
    if (file) {
      if (file instanceof File) {
        formData.append('files', file, file.name);
      } else {
        formData.append('files', file);
      }
    }
  });

  const url = `/v1/identities/${identityId}/answer/${answerId}/upload`;
  const resp = await fetch(url, {
    credentials: 'include',
    method: 'POST',
    body: formData,
  });

  if (!resp.ok) {
    httpErrorHandler(resp);
    throw new UploadDocumentsError();
  }

  return resp.json();
};
